import { Categories, LensDirectOrderCalculationRequestBody, LensDirectOrderCalculationResponse, Product } from '@/models';
import { GenericService } from './generic.service';
import apiClient from './client/apiClient';

export interface WebshopProduct {
  id: string;
  name: string;
  mlsId: string;
  category: string;
  image?: string;
}

export class WebshopService extends GenericService<Categories> {
  private organisationalUnit: string;

  constructor(organisationalUnit: string) {
    super(`v1/webshop/${organisationalUnit}/categories`);
    this.organisationalUnit = organisationalUnit;
  }

  async getProducts(categorySlug: string): Promise<Product[]> {
    const response = await apiClient.get<Product[]>(`${this.endpoint}/${categorySlug}/products`);
    return (response?.data ?? response ?? []) as Product[];
  }

  async getAllProducts() {
    return await apiClient.get<Product[]>(`v1/webshop/products/${this.organisationalUnit}`);
  }

  async calculateLens(
    lensId: string,
    params: LensDirectOrderCalculationRequestBody
  ): Promise<LensDirectOrderCalculationResponse> {
    const url = `v1/webshop/${this.organisationalUnit}/lens/${lensId}/calculate`;
    return await apiClient.get(url, {
      params: {
        changed_params: JSON.stringify(params.changed_params),
        current_params: JSON.stringify(params.current_params)
      }
    });
  }
}
